var _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 9.58789,
    cy: 6,
    r: 5.5,
    stroke: "#74A3C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M18.588 22C18.588 16.4772 14.5585 12 9.58798 12C5.5581 12 2.14684 14.9429 1 19",
    stroke: "#74A3C7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5879,
    cy: 19,
    r: 5,
    fill: "#5EBB47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.5L17 20.5L19.5 17",
    stroke: "white",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.8b01ef64fb5e51e018bc77ae1de35e2c.svg";
export { ForwardRef as ReactComponent };